import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, HeadphonesIcon, AlertCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = [{
    icon: BookOpenIcon,
    title: 'Ebook Terapia de Sueño 7-Min',
    description: 'La guía paso a paso con el método 1-2-4 detallado.'
  }, {
    icon: HeadphonesIcon,
    title: 'Audiolibro "Tu Voz es su Calma"',
    description: 'Guía narrativa para que la escuches mientras arrullas a tu bebé (tú solo sigues las instrucciones).'
  }, {
    icon: AlertCircleIcon,
    title: 'Guía de Emergencia 3 AM',
    description: 'Qué hacer exactamente cuando despierta a mitad de la noche para que vuelva a dormir en minutos.'
  }, {
    icon: CheckCircle2Icon,
    title: 'Checklist "Estación de Calma"',
    description: 'Cómo preparar la habitación perfecta para el sueño profundo.'
  }];
  return <section ref={ref} className="w-full bg-cream py-16 md:py-24 px-6" data-id="element-176">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-5xl mx-auto" data-id="element-177">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-12 text-center" data-id="element-178">
          Todo lo que recibes hoy
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-179">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-180">
                <Icon className="w-10 h-10 text-soft-gold mb-4" data-id="element-181" />
                <h3 className="font-serif text-xl md:text-2xl font-semibold text-warm-brown mb-3" data-id="element-182">
                  {item.title}
                </h3>
                <p className="text-base md:text-lg text-warm-brown/80 leading-relaxed" data-id="element-183">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </section>;
}